import { render, staticRenderFns } from "./PosCashManagement.vue?vue&type=template&id=0361ea38&scoped=true"
import script from "./PosCashManagement.vue?vue&type=script&lang=js"
export * from "./PosCashManagement.vue?vue&type=script&lang=js"
import style0 from "./PosCashManagement.vue?vue&type=style&index=0&id=0361ea38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361ea38",
  null
  
)

export default component.exports